// src/components/guides/guideIcons.jsx
// Allowlisted icon keys for guide docs (kept out of defaultGuides.js so the
// pack stays pure data for the node tests). Unknown key → HelpOutline, so a
// typo in an authored guide degrades gracefully instead of crashing.

import SchoolIcon from '@mui/icons-material/School';
import CampaignIcon from '@mui/icons-material/Campaign';
import AssignmentAddIcon from '@mui/icons-material/AssignmentAdd';
import CakeIcon from '@mui/icons-material/Cake';
import LiquorIcon from '@mui/icons-material/Liquor';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const GUIDE_ICONS = {
  school: SchoolIcon,
  campaign: CampaignIcon,
  list: AssignmentAddIcon,
  cake: CakeIcon,
  liquor: LiquorIcon,
  restaurant: RestaurantIcon,
  door: MeetingRoomIcon,
  atm: LocalAtmIcon,
  personAdd: PersonAddIcon,
  badge: EmojiEventsIcon
};

export function guideIcon(key) {
  return GUIDE_ICONS[key] || HelpOutlineIcon;
}
